import {useMutation} from "@tanstack/react-query";
import {createClaimCategory} from "../services/ClaimCategoryService";

export function useClaimCategoryCreate() {
    return useMutation({
        mutationFn: createClaimCategory,
    });
}
